<template>
  <div v-if="organisation">
    <div class="alert alert-warning text-center" v-if="isHidden">
      {{ $t('sentence.organisation_profile_page_invisible') }}
    </div>

    <v-organisation-view-default
      v-if="organisation.type === 'default'"
      :organisation="organisation"
    />
    <v-organisation-view-media-agency
      v-else-if="organisation.type === 'media_agency'"
      :organisation="organisation"
    />
  </div>
</template>

<script>
import OrganisationViewDefault from '@/reviewer/components/OrganisationViewDefault.vue';
import OrganisationViewMediaAgency from '@/reviewer/components/OrganisationViewMediaAgency.vue';
import { fetchOrganisation } from '@/public/api';
import { pageNotFound } from '@/common/utils/notify';

export default {
  name: 'OrganisationDetail',
  components: {
    'v-organisation-view-default': OrganisationViewDefault,
    'v-organisation-view-media-agency': OrganisationViewMediaAgency,
  },
  data() {
    return {
      organisation: null,
    };
  },
  computed: {
    isHidden() {
      return this.organisation.type === 'media_agency' && !this.organisation.has_paid_license;
    },
  },
  methods: {
    async fetchOrganisation() {
      const response = await fetchOrganisation(this.$route.params.slug);
      if (response.status !== 200) {
        pageNotFound();
        return;
      }
      this.organisation = response.data;
    },
  },
  created() {
    this.fetchOrganisation();
  },
};
</script>
